import React, { createContext, useState } from "react";

// Krijo kontekstin
export const FiscalYearContext = createContext();

export const FiscalYearProvider = ({ children }) => {
    // Merr vitin aktual
    const currentYear = new Date().getFullYear();

    // Vendos si default vitin aktual
    const [fiscalYear, setFiscalYear] = useState(currentYear);

    return (
        <FiscalYearContext.Provider value={{ fiscalYear, setFiscalYear }}>
            {children}
        </FiscalYearContext.Provider>
    );
};
